import React from 'react';
import TestimonialCard from './TestimonialCard';
import Button from './Button';
const TestimonialSection = () => {
  return <div className="w-full bg-pink-50 text-gray-800 py-16 px-4" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <div className="bg-white rounded-lg shadow-md p-6 mb-10 border border-gray-200" data-id="element-204">
          <div className="flex items-center mb-4" data-id="element-205">
            <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Magda_52" className="w-10 h-10 rounded-full mr-4" data-id="element-206" />
            <div data-id="element-207">
              <h3 className="font-bold" data-id="element-208">Magda_52</h3>
              <p className="text-sm text-gray-500" data-id="element-209">Dołączyła: 2019</p>
            </div>
          </div>
          <h3 className="text-xl font-bold mb-4" data-id="element-210">
            "Dziewczyny, znalazłam coś, co naprawdę działa"
          </h3>
          <p className="text-lg mb-4" data-id="element-211">
            Od miesięcy czytałam o tych badaniach dr Radeckiej i szukałam
            sposobu, żeby zastosować to w praktyce. Myślałam, że sama sobie
            ułożę plan, ale zawsze kończyło się tym, że dodawałam sobie kolejne
            obowiązki.
          </p>
          <p className="text-lg mb-4" data-id="element-212">
            Aż trafiłam na e-book oparty bezpośrednio na metodzie dr Radeckiej.
            Dziewczyny, to nie jest kolejny poradnik. To jest dokładnie to,
            czego szukałam – krok po kroku, jak odzyskać siebie w 15 minut
            dziennie.
          </p>
          <p className="text-lg mb-4" data-id="element-213">
            Nie wierzyłam, że to może działać. Ale po dwóch tygodniach...
            dziewczyny, ja zaczęłam CZUĆ. Przypomniałam sobie, że kiedyś lubiłam
            malować. Że marzyłam o podróży do Grecji. Że jestem Magda, a nie
            tylko mama-Irenki-i-córka-pani-Zosi.
          </p>
          <div className="mt-6 space-y-4" data-id="element-214">
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-215">
              <p className="text-gray-800" data-id="element-216">
                <span className="font-bold" data-id="element-217">Ania78:</span> Magda, błagam, gdzie
                to znalazłaś? Podaj link!
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-218">
              <p className="text-gray-800" data-id="element-219">
                <span className="font-bold" data-id="element-220">Monika_K:</span> Też chcę! Mam dość
                bycia nikim!
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-221">
              <p className="text-gray-800" data-id="element-222">
                <span className="font-bold" data-id="element-223">Basia50:</span> 15 minut to mogę
                wykroić nawet ja... ale czy to naprawdę działa?
              </p>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-224">
              <p className="text-gray-800" data-id="element-225">
                <span className="font-bold" data-id="element-226">Ela_W:</span> Czytałam o dr
                Radeckiej, ale nigdzie nie mogłam znaleźć praktycznego
                przewodnika!
              </p>
            </div>
          </div>
          <div className="mt-6 bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400" data-id="element-227">
            <p className="text-gray-800" data-id="element-228">
              <span className="font-bold" data-id="element-229">Magda_52:</span> To e-book 'Nie
              zapomnij o sobie'. Nie jest to zwykły poradnik, tylko praktyczny
              przewodnik oparty na metodzie dr Radeckiej. 12 rozdziałów, każdy z
              mikropraktyką na 15 minut. Po trzech tygodniach czuję się jak
              człowiek, nie jak automat.
            </p>
          </div>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-gray-700" data-id="element-230">
          Zeszyt, który stał się moim ratunkiem
        </h2>
        <p className="text-lg mb-6" data-id="element-231">
          Znalazłam ten e-book. "Nie zapomnij o sobie" – prosty tytuł, ale
          trafił mnie prosto w serce.
        </p>
        <p className="text-lg mb-6" data-id="element-232">
          Gdy go otworzyłam, od razu wiedziałam, że to coś innego niż wszystko,
          co czytałam wcześniej.
        </p>
        <div className="bg-amber-50 p-6 rounded-lg shadow-md my-8 border-l-4 border-amber-400" data-id="element-233">
          <p className="text-xl italic" data-id="element-234">
            "Ten e-book nie jest po to, żebyś coś zmieniała. Jest po to, żebyś
            nie zniknęła całkiem."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-235">
          Nie musiałam niczego zmieniać. Nie musiałam być lepsza, silniejsza,
          bardziej zorganizowana.
        </p>
        <p className="text-lg mb-6" data-id="element-236">Musiałam tylko... nie zniknąć.</p>
        <p className="text-lg mb-6" data-id="element-237">
          To było pierwsze w życiu "zadanie", które czułam, że dam radę.
        </p>
        <div className="my-12 bg-amber-100 p-8 rounded-lg shadow-lg border-2 border-amber-300" data-id="element-238">
          <p className="text-xl font-bold mb-6 text-center" data-id="element-239">
            Czy też marzysz o tym, by znów poczuć się sobą?
          </p>
          <p className="text-lg mb-6" data-id="element-240">
            E-book "Nie zapomnij o sobie" to 12 rozdziałów z praktycznymi
            ćwiczeniami, które pomogły już tysiącom kobiet odzyskać swoją
            tożsamość.
          </p>
          <div className="mt-6 flex justify-center" data-id="element-241">
            <Button data-id="element-242" />
          </div>
        </div>
        <h3 className="text-xl md:text-2xl font-bold mt-12 mb-6" data-id="element-243">
          Pierwsze 15 minut – moment, który pamiętam do dziś
        </h3>
        <p className="text-lg mb-6" data-id="element-244">
          Metoda była prosta, ale precyzyjna. Każdy z 12 rozdziałów zawierał:
        </p>
        <ul className="mb-8 space-y-4" data-id="element-245">
          <li className="flex items-start" data-id="element-246">
            <span className="text-amber-500 mr-2" data-id="element-247">•</span>
            <span className="text-lg" data-id="element-248">
              Słowa wsparcia – jakby mówiła do mnie bliska przyjaciółka, która
              naprawdę rozumie
            </span>
          </li>
          <li className="flex items-start" data-id="element-249">
            <span className="text-amber-500 mr-2" data-id="element-250">•</span>
            <span className="text-lg" data-id="element-251">
              Ćwiczenie pisemne – które pozwalało mi zatrzymać się i zajrzeć w
              głąb siebie bez presji
            </span>
          </li>
          <li className="flex items-start" data-id="element-252">
            <span className="text-amber-500 mr-2" data-id="element-253">•</span>
            <span className="text-lg" data-id="element-254">
              Mikropraktykę – mały, łagodny rytuał na 3-15 minut
            </span>
          </li>
        </ul>
        <p className="text-lg mb-6" data-id="element-255">
          Pierwsze ćwiczenie wydawało się absurdalnie proste:
        </p>
        <div className="bg-amber-50 p-6 rounded-lg shadow-md my-8" data-id="element-256">
          <p className="text-lg italic" data-id="element-257">
            "Napisz swoje imię. Powtórz je na głos trzy razy, jakbyś mówiła do
            kogoś, kogo kochasz."
          </p>
        </div>
        <p className="text-lg mb-6" data-id="element-258">
          Brzmi głupio? Też tak myślałam. Ale gdy to zrobiłam...
        </p>
        <p className="text-xl text-center my-6 font-bold" data-id="element-259">
          "Kasia. Kasia. Kasia."
        </p>
        <p className="text-lg mb-6" data-id="element-260">
          Kiedy ostatnio ktoś wypowiedział moje imię z czułością? Kiedy ja sama
          pomyślałam o sobie z życzliwością?
        </p>
        <p className="text-lg mb-6" data-id="element-261">
          Tego dnia płakałam przez pięć minut. Ale to nie był płacz rozpaczy. To
          była ulga.
        </p>
        <p className="text-lg mb-6 font-bold" data-id="element-262">
          Po raz pierwszy od lat poczułam swoją obecność.
        </p>
      </div>
    </div>;
};
export default TestimonialSection;